import { useEffect, useState } from 'react';

const CircularProgress = ({ percentage, size = 120, strokeWidth = 6, duration = 1000 }) => {
  const [progress, setProgress] = useState(0);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  useEffect(() => {
    let start = 0;
    const increment = percentage / (duration / 16); // update every ~16ms (60fps)
    const animate = () => {
      start += increment;
      if (start < percentage) {
        setProgress(Math.round(start));
        requestAnimationFrame(animate);
      } else {
        setProgress(percentage);
      }
    };
    animate();
  }, [percentage, duration]);
  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        style={{
          transform: 'rotate(-90deg)' // ✅ start at 12 o’clock, move clockwise
        }}
      >
        <defs>
          <linearGradient id="gradient" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#00C49F" />
            <stop offset="100%" stopColor="#0088FE" />
          </linearGradient>
        </defs>
        {/* Background Circle */}
        <circle stroke="#e5e7eb" fill="transparent" strokeWidth={strokeWidth} cx={size / 2} cy={size / 2} r={radius} />
        {/* Progress Circle */}
        <circle
          stroke="url(#gradient)"
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{
            transition: 'stroke-dashoffset 0.1s linear'
          }}
        />
      </svg>
      {/* Center Percentage Text */}
      <div className={`absolute ${progress === 0 ? 'text-red-600' : 'text-green-600'} text-2xl font-semibold`}>
        {progress}%
      </div>
    </div>
  );
};
export default CircularProgress;
